import defaultIcon from "Assets/images/gexinghuashezhi/defaultIcon.svg";
import businessIcon from "Assets/images/gexinghuashezhi/business.svg";
import industryIcon from "Assets/images/gexinghuashezhi/industry.svg";
import simpleIcon from "Assets/images/gexinghuashezhi/simple.svg";
import youthIcon from "Assets/images/gexinghuashezhi/youth.svg";


export default {
    defaultIcon,
    businessIcon,
    industryIcon,
    simpleIcon,
    youthIcon
}